import { DropdownMenuItem } from '@/components/DropdownMenu'

import { useRoutingLayoutMenu } from '../hooks/useRoutingLayoutMenu'
import { useTexts } from '../useTexts'
import { TickIcon } from './TickIcon'
import { Spacer } from './Spacer'

export function SplitLayoutItem() {
  const texts = useTexts()
  const { setToSplit, layoutMode } = useRoutingLayoutMenu()

  return (
    <DropdownMenuItem
      onClick={setToSplit}
      LeftIcon={layoutMode === 'split' ? <TickIcon /> : <Spacer />}
      data-testid="header__layout-menu-split"
    >
      {texts.splitView}
    </DropdownMenuItem>
  )
}
